import React, {memo} from 'react'
import Image from 'gatsby-image'

import * as CardCSS from './css/card.module.css'

import {DownloadState} from '../DownloadStates'

export default memo(function Card({extension, rapid}) {
  return (
    <div className="d-flex col-10 col-sm-8 col-md-6 col-lg-4 my-3">
      <div className={`${CardCSS.card} card border-0`}>
        <Image
          sizes={{...extension.image_card.sharp.fluid, aspectRatio: 2 / 1}}
          className={`${CardCSS.img} card-img-top`}
          alt={extension.title}
        />
        <div className={`${CardCSS.body} card-body d-flex flex-column`}>
          <h4 className={`${CardCSS.title}`}>{extension.title}</h4>
          <p className={`${CardCSS.description} flex-grow-1`}>{extension.description_card}</p>
          <div className="text-center">
            <DownloadState ext={extension} rapid={rapid} />
          </div>
        </div>
      </div>
    </div>
  )
})
